import React, {useContext} from 'react';
import {Form, Button} from 'react-bootstrap';
import BootstrapNavbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import {GiTap} from 'react-icons/gi';
import {HiOutlineDocumentReport} from 'react-icons/hi';
import {TiWarningOutline} from 'react-icons/ti';
import {RiRemoteControlFill, RiWaterFlashFill} from 'react-icons/ri';
import {BiLogOutCircle} from 'react-icons/bi';
import {MdOutlineHistory} from "react-icons/md";
import {ImUsers} from 'react-icons/im';
import * as logo from '../../Images/wint-logo-small.png';
import './Navbar.css';
import {store} from "../../Store/store";
import {hasAdminRoles} from "../../General/SharedMethods";
import {IoHardwareChipOutline} from "react-icons/io5";

export default function Navbar(props) {
    const globalState = useContext(store);

    const getClassName = (route) => {
        if (window.location.toString().endsWith(route) || (window.location.toString().includes(route) && route === '/controlUnits')) {
            return "navbar-selected-tab"
        }
    }

    const navLinkStyle = {
        verticalAlign: 'center',
        display: props.isSignedOutPage ? 'none' : 'inline-flex',
        zIndex: 9999
    }

    const navLinkTitleStyle = {
        top: 7,
        position: 'relative'
    }

    const logOutButtonStyle = {
        position: 'absolute',
        right: 0,
        zIndex: 9999
    }

    const logInButtonStyle = {
        position: 'absolute',
        right: 0,
        zIndex: 9999,
        marginTop: '-1.5vw'
    }

    return (
        <BootstrapNavbar bg="light" variant="light" expand="lg">
            <BootstrapNavbar.Brand>
                <img
                    src={logo.default}
                    alt="logo"
                />
            </BootstrapNavbar.Brand>
            <Nav className="mr-auto">
                {hasAdminRoles(globalState.state.userRole) &&
                    <Nav.Link href="/monitoring" style={navLinkStyle} className={getClassName("/monitoring")}>
                        <h3><GiTap/></h3>
                        <p style={navLinkTitleStyle}>Leaks</p>
                    </Nav.Link>
                }
                {hasAdminRoles(globalState.state.userRole) &&
                    <Nav.Link href="/monitoringHistory" style={navLinkStyle} className={getClassName("/monitoringHistory")}>
                        <h3><MdOutlineHistory/></h3>
                        <p style={navLinkTitleStyle}>Leaks History</p>
                    </Nav.Link>
                }
                {hasAdminRoles(globalState.state.userRole) &&
                    <Nav.Link href="/errors" style={navLinkStyle} className={getClassName("/errors")}>
                        <h3><TiWarningOutline/></h3>
                        <p style={navLinkTitleStyle}>Errors</p>
                    </Nav.Link>
                }
                <Nav.Link href="/waterSystems" style={navLinkStyle} className={getClassName("/waterSystems")}>
                    <h3><RiWaterFlashFill/></h3>
                    <p style={navLinkTitleStyle}>Water Systems</p>
                </Nav.Link>
                {hasAdminRoles(globalState.state.userRole) &&
                    <Nav.Link href="/controlUnits" style={navLinkStyle} className={getClassName("/controlUnits")}>
                        <h3><RiRemoteControlFill/></h3>
                        <p style={navLinkTitleStyle}>Control Units</p>
                    </Nav.Link>
                }
                {hasAdminRoles(globalState.state.userRole) &&
                    <Nav.Link href="/hardwareCatalog" style={navLinkStyle} className={getClassName("/hardwareCatalog")}>
                        <h3><IoHardwareChipOutline/></h3>
                        <p style={navLinkTitleStyle}>Hardware Catalog</p>
                    </Nav.Link>
                }
                <Nav.Link href="/reports" style={navLinkStyle} className={getClassName("/reports")}>
                    <h3><HiOutlineDocumentReport/></h3>
                    <p style={navLinkTitleStyle}>Reports</p>
                </Nav.Link>
                {hasAdminRoles(globalState.state.userRole) &&
                    <Nav.Link href="/users" style={navLinkStyle} className={getClassName("/users")}>
                        <h3><ImUsers/></h3>
                        <p style={navLinkTitleStyle}>Users</p>
                    </Nav.Link>
                }
                {!props.isSignedOutPage &&
                    <Nav.Link href="/signed-out?logout=true" style={logOutButtonStyle}>
                        <Form inline={"true"}>
                            <Button>
                                <BiLogOutCircle/>
                            </Button>
                        </Form>
                    </Nav.Link>
                }
                {props.isSignedOutPage
                    && <Nav.Link href="/" style={logInButtonStyle}>
                        <Form inline>
                            <Button variant={"success"} onClick={() => window.location.reload(false)}>
                                Log In
                            </Button>
                        </Form>
                    </Nav.Link>
                }
            </Nav>
        </BootstrapNavbar>)
}
